import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/radio/style/index.js
// module id = 193
// module chunks = 0